// extracted by mini-css-extract-plugin
export var dropdown = "_tx-0";
export var imageWrapper = "_tx-3";
export var itemNameContainer = "_tx-1";
export var productImage = "_tx-2";
export var spinnerWrapper = "_tx-4";